import { createElement, memo, useCallback, useState, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import ScrollView from '@hfe/max-scrollview';
import Text from '@hfe/max-text';
import { isAndroid, getImage } from '../../util';
import TextInput from '@hfe/max-textinput';
import './SearchArea.scss';
import '../CitySelection.scss';
import SuggestAreaItem from '../SuggestAreaItem/SuggestAreaItem';
const isMRN = false;
import { getCityList } from '../cityUtil';
function SearchArea(p) {
    var _a;
    const [searchValue, setSearchValue] = useState('');
    const { city, userInfo } = (_a = p.allStates) !== null && _a !== void 0 ? _a : {};
    const [suggestAreaList, setSuggestAreaList] = useState([]);
    const emitCloseEventCallback = useCallback(() => {
        p.onClose();
    }, []);
    function getAreaSuggest(array) {
        let list = [];
        for (const item of array) {
            if (item.data) {
                list = list.concat(item.data.filter(dataItem => { var _a; return (_a = dataItem === null || dataItem === void 0 ? void 0 : dataItem.name) === null || _a === void 0 ? void 0 : _a.includes(searchValue); }));
            }
        }
        return list;
    }
    const allCityList = getCityList(p === null || p === void 0 ? void 0 : p.cityData);
    useEffect(() => {
        const res = getAreaSuggest(allCityList);
        setSuggestAreaList(res);
        p.emitSearchValueChange(searchValue);
    }, [searchValue, city, userInfo]);
    const textinputStyle = isAndroid && isMRN ? {
        paddingTop: '8rpx'
    } : {};
    return <View className="search-area-fixed-container" style={searchValue !== '' ? {
        height: isMRN ? '90%' : '90vh'
    } : {}}>
      <View className="search-area-container">
        <View className="search-area-input-container">
          <Image className="search-area-search-icon" source={getImage('https://p0.meituan.net/travelcube/20cedfd450e06a9260d775e1a634bdac2015.png')}/>
          <TextInput className="search-area-input" style={textinputStyle} placeholderColor="#999999" placeholder="城市" onChangeText={value => setSearchValue(value)}/>
        </View>
        <Image className="search-area-close" source={getImage('https://p0.meituan.net/travelcube/cb0a0d5f24e2d7b5300e931209e2db1d743.png')} onClick={emitCloseEventCallback} style={{
        pointerEvents: 'auto'
    }}/>
      </View>
      <ScrollView x-if={searchValue !== '' && suggestAreaList.length > 0} class="search-area-suggest-container" style={{
        zIndex: 999,
        height: '100%'
    }}>
        {suggestAreaList.map((item, index) => {
        item.index = index;
        console.log(item, 'item');
        return <View className='city-result'>
              <SuggestAreaItem areaSuggest={item} emitCity={p === null || p === void 0 ? void 0 : p.emitCity} cityType={p.cityType}/>
              <View className="city-selection-divider"/>
            </View>;
    })}
      </ScrollView>
      <View x-if={searchValue !== '' && suggestAreaList.length === 0} className="search-area-not-found" style={{
        zIndex: 999,
        height: '100%'
    }}>
        <Image className="search-area-not-found-image" source={getImage('https://p0.meituan.net/travelcube/18381003590d63358f310f8a5801e512163558.png')}/>
        <View className="search-area-not-found-text-container">
          <Text className="search-area-not-found-text-normal">未找到相关 </Text>
          <Text className="search-area-not-found-text-blue">城市</Text>
        </View>
        <Text className="search-area-not-found-text-bottom">请稍后重试</Text>
      </View>
    </View>;
}
export default memo(SearchArea);
